import { createSlice } from "@reduxjs/toolkit";
import { getEmployeeList } from "./ThunkActions";
import { iEmployeeState, REDUCER_NAME } from "./Types";

// Define initial state based on the provided structure
const initialState: iEmployeeState = {
  isLoading: false,
  employeeList: [],
  errorMessage: null,
};

export const employeeSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetEmployeeState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEmployeeList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getEmployeeList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.employeeList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getEmployeeList.rejected, (state) => {
        state.errorMessage = "Failed to fetch delivery man list";
        state.isLoading = false;
      });
  },
});

export const { resetEmployeeState } = employeeSlice.actions;
export default employeeSlice.reducer;
